// extracted by mini-css-extract-plugin
module.exports = {"cart-items":"Cart_cart-items__kvCw2","total":"Cart_total__ktsj9","actions":"Cart_actions__1Qtn2","buttonAlt":"Cart_buttonAlt__2KpzR","button":"Cart_button__2J9v1"};